import React, { useRef, useEffect, useCallback, useState} from 'react';
import {useDoubleClick} from "components/hooks/useDoubleClick.js";
import {connect} from 'react-redux';

const MessageComponent = ({effect}) => { 
    let ref = useRef(undefined);
    let [text, setText] = useState(effect.messageText);
    let [editing, setEditing] = useState(false);

    const onDoubleClick = useDoubleClick(() => setEditing(true), 250, () => effect.execute());

    useEffect(() => {
        if (editing) {
            ref.current.focus();
        }
    }, [editing]);
    
    const onKeyDown = useCallback((e) => {
        if (e.key === "Enter") {
            effect.messageText = text;
            effect.execute();
            setEditing(false);
        }
    }, [setEditing, text]);

    return (
        <div  onMouseDown={e => {if (editing) e.stopPropagation();}} className="message-button">
          {!editing ? <div onClick={onDoubleClick} className="message-content">{text}</div> :
           <input
             ref={ref}
             onKeyDown={onKeyDown}
             value={text}
             onChange={e => setText(e.target.value)}>
           </input>}
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MessageComponent);
